import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { notify } from "react-notify-toast";
import Spinner from "../../Components/Spinner";
import { PORT } from "../../config";
// import logo from '../../assets/img/logo_right-removebg.png';
import { GoogleLogin } from "react-google-login";
import PasswordStrengthMeter from "./PasswordStrengthMeter";
import { LinkedInLoginButton } from 'react-social-login-buttons';
import "./Register.css";
import Auth from "../../Auth/Auth";
import { updateToRoot } from "../../redux/homePage/homePage.actions";
import SignupContainer from "../Signup-Login/SignupContainer";
import GoogleDivider from "../Signup-Login/GoogleDivider";
import LinkToCreateAccount from "../Signup-Login/LinkToCreateAccount";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import CancelButton from "../../Components/Buttons/CancelButton";
import FormField from "../../Components/FormField/FormField";
import PasswordToggle from "../../Components/FormField/PasswordToggle";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import TermsAndConditionsTeacher from "./TermsAndConditionsTeacher";
import SignupToggle from "../Signup-Login/SignupToggle";
import { API } from "../../API";

const Register = (props) => {
  const [viewedTermsAndConditions, setViewTermsAndConditions] = useState(false);
  const [email, setEmail] = useState("");
  const [emailformat, setemailformat] = useState(false);
  const [ishotmail, setishotmail] = useState(true);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordStrength, setPasswordStrength] = useState("");
  const [checkPassword, setCheckPassword] = useState([]);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [isRegistered, setIsRegistered] = useState(false);
  const [error, setError] = useState(false);
  // This bit of state provides user feedback in the component when something
  // changes. isSendingEmail is flipped just before the fetch request is sent in
  // onSubmit and then flipped back when data has been received from the server.
  // How many times is the 'isSendingEmail' variable used below?
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [isGoogleButton, setIsGoogleButton] = useState(true);
  const [childcare,setchildcare] = useState(false)
  const URL = PORT;
  const { updateToRoot } = props;

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (emailformat) {
      if (!ishotmail) {
        if (passwordStrength >= 1 && checkPassword.length == 0) {
          if (password === confirmPassword) {
            setError(false);
            if (document.getElementById("terms-co-check").checked === true) {
              setIsSendingEmail(true);

              // Extract teacher options from location state
              const is_elt = props.location.state.is_elt;
              const is_vet = props.location.state.is_vet;
              const state = props.location.state.state;
              const is_childhood_teacher = props.location.state.is_childhood_teacher;
              const preferred_country1 = props.location.state.preferred_country1;
              const level = is_childhood_teacher ? "cert" : "junior";
              setchildcare(is_childhood_teacher)
              await API.register({
                email,
                password,
                is_elt,
                is_vet,
                state,
                preferred_country1,
                is_childhood_teacher,
                level
              })
                .then((res) => {
                  console.log(res.data);
                  if (res.data.reason === "user-existent-email") {
                    // console.log(res.data);
                    notify.show(
                      <React.Fragment>
                        {res.data.msg}
                        <a href="/Login">
                          <b>login screen</b>.
                        </a>
                      </React.Fragment>
                    );
                  } else if (res.data.reason === "customer-existent-email") {
                    notify.show(
                      <React.Fragment>
                        {res.data.msg}
                        <a href="/LoginAsInstitution">
                          <b>login screen</b>.
                        </a>
                      </React.Fragment>
                    );
                  } else if (res.data.reason === "personnel-existent-email") {
                    notify.show(
                      <React.Fragment>
                        {res.data.msg}
                        <a href="/LoginAsInstitution">
                          <b>login screen</b>.
                        </a>
                      </React.Fragment>
                    );
                  } else {
                    notify.show(res.data.msg);
                  }
                  setIsSendingEmail(false);
                  res.data.email
                    ? setIsRegistered(false)
                    : setIsRegistered(true);
                })
                .catch((err) => {
                  setIsSendingEmail(false);
                  notify.show("Error when sign up. Please try again later.");
                  console.log("Register.js: ", err);
                });
            } else {
              notify.show("Please accept the Terms and Conditions.");
            }
          } else {
            setError(true);
            notify.show("Passwords do not match.");
          }
        } else {
          notify.show("Check the required password conditions.");
        }
      } else {
        notify.show(
          "We apologise that our application is not accessible with Hotmail or Outlook email addresses. Please use another email provider such as Gmail to signup."
        );
      }
    } else {
      notify.show("Please use a correct email format.");
    }
  };
  const togglePassword = () => {
    //Toggles between showing and hiding password
    setShowPassword(!showPassword);
  };

  const hideGoogleRegisterForm = () => {
    document.getElementById("google-register-form").style.display = "none";
  };
  const showGoogleRegisterForm = () => {
    document.getElementById("google-register-form").style.display = "block";
    hideLinkedinRegisterForm();
    hideEmailAndPassRegisterForm();
    // document.getElementById('linkedin-register-button').disabled;
    // document.getElementById('linkedin-register-button').style.opacity='20%';
    // document.getElementById('email-and-pssw-button').disabled;
    // document.getElementById('email-and-pssw-button').style.opacity='20%';
  };

  const hideLinkedinRegisterForm = () => {
    document.getElementById("linkedin-register-form").style.display = "none";
  };
  // const showLinkedinRegisterForm = () => {
  //   document.getElementById('linkedin-register-form').style.display = 'block';
  //   hideGoogleRegisterForm();
  //   hideEmailAndPassRegisterForm();
  //   // document.getElementById('google-register-button').removeAttribute('onclick');
  //   // document.getElementById('google-register-button').style.opacity='20%';
  //   // document.getElementById('email-and-pssw-button').disabled;
  //   // document.getElementById('email-and-pssw-button').style.opacity='20%';
  // };

  const hideEmailAndPassRegisterForm = () => {
    document.getElementById("emailandpass-register-form").style.display =
      "none";
  };
  const showEmailAndPassRegisterForm = () => {
    document.getElementById("emailandpass-register-form").style.display =
      "block";
    hideLinkedinRegisterForm();
    hideGoogleRegisterForm();
  };

  const toggleConfirmPassword = () => {
    //Toggles between showing and hiding password
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handlePasswordStrength = () => {
    setPasswordStrength(document.querySelector("progress").value);
  };

  const responseFromGoogle = async (response) => {
    // console.log(response)
    if (response.profileObj) {
      await API.loginGoogle(response.tokenId)
        .then((res) => {
          const data = res.data.user;
          let path = "";
          if (data.email_verification_status) {
            let userType = window.localStorage.getItem('userType');
            window.localStorage.clear();
            window.localStorage.setItem('userType', userType);
            window.localStorage.setItem("token", res.data.token);
            window.localStorage.setItem("userID", res.data.user._id);
            Auth.login();
            // window.localStorage.setItem("user", JSON.stringify(data))
            // window.localStorage.setItem("shared_teacher",JSON.stringify(data))
            updateToRoot(res.data.user);
            path = {
              pathname: "/dashboard",
            };
            props.history.push(path);
          } else {
            path = `/confirm?id=${data._id}`;
            window.location.href = path;
          }
        })
        .catch(async (err) => {
          // Extract teacher options from location state
          const is_elt = props.location.state.is_elt;
          const is_vet = props.location.state.is_vet;
          const state = props.location.state.state;
          const is_childhood_teacher = props.location.state.is_childhood_teacher;
          const preferred_country1 = props.location.state.preferred_country1;
          const level = is_childhood_teacher ? "cert" : "junior";
          setchildcare(is_childhood_teacher)
          await API.googleRegistration({
            email: response.profileObj.email,
            is_elt: is_elt,
            is_vet: is_vet,
            state: state,
            preferred_country1: preferred_country1,
            is_childhood_teacher: is_childhood_teacher,
            level: level
          })
            .then((res) => {
              console.log(res);
              switch (res.data.reason) {
                case "customer-existent-email":
                  console.log('customer-existent-email res.data', res.data);
                  notify.show(
                    <React.Fragment>
                      {res.data.msg}
                      <a href="/LoginAsInstitution">
                        <b>login screen</b>.
                      </a>
                    </React.Fragment>
                  );
                  break;
                case "personnel-existent-email":
                  console.log('personnel-existent-email res.data', res.data);
                  notify.show(
                    <React.Fragment>
                      {res.data.msg}
                      <a href="/LoginAsInstitution">
                        <b>login screen</b>.
                      </a>
                    </React.Fragment>
                  );
                  break;
                case "user-existent-email":
                  notify.show(
                    <React.Fragment>
                      {res.data.msg}
                      <a href="/Login">
                        <b>login screen</b>.
                      </a>
                    </React.Fragment>
                  );
                  break;
                default:
                  setIsRegistered(true);
                  break;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        });
    } else {
      console.log("Fail");
      console.log(response);
    }
  };

  const redirectURL = `${window.location.href.split('#')[0]}`
  const handleLinkedInClick = () => {
    localStorage.setItem('stateData', JSON.stringify(props.location.state));
    setchildcare(props.location.state.is_childhood_teacher)
    window.location.href = 'https://www.linkedin.com/oauth/v2/authorization' + 
      '?response_type=code' +
      '&client_id=78d14xqbsjs82q' + 
      '&redirect_uri=' + redirectURL.split('?')[0] +
      '&state=linkedin' + 
      '&scope=openid%20profile%20email';
  };
  
  const urlParams = new URLSearchParams(window.location.search);
  const newcode = urlParams.get('code');
  const handleLinkedInCallback = async (code) => {
    try {
      const stateData = localStorage.getItem('stateData');
      const stateDataString = JSON.parse(stateData);
      const is_elt = stateDataString.is_elt;
      const is_vet =stateDataString.is_vet;
      const is_childhood_teacher = stateDataString.is_childhood_teacher;
      const state = stateDataString.state;
      const city = stateDataString.city;
      const preferred_country1 = stateDataString.preferred_country1;
      const level = is_childhood_teacher ? "cert" : "junior";
      // setchildcare(is_childhood_teacher)
      const response = await API.updateFromLinkedin(
        {code:code,
          is_elt: is_elt,
          is_vet: is_vet,
          state: state,
          city: city,
          preferred_country1: preferred_country1,
          is_childhood_teacher: is_childhood_teacher,
          level: level,
          redirect : redirectURL.split('?')[0]
        })
      if(response.data.success){
        if(response.data.data.new){
          window.localStorage.setItem("userType", response.data.data.role);
          props.history.push(response.data.data.url)
        }else{
            window.localStorage.setItem("userType", response.data.data.role);
            window.localStorage.setItem("token", response.data.data.token);
            window.localStorage.setItem("userID", response.data.data.user._id);
            setIsRegistered(true);
            Auth.login();
            updateToRoot(response.data.data.user);
            const path = {
              pathname: "/dashboard",
            };
            props.history.push(path);
          }
      }
    } catch (error) {
      console.error('Error:', error);
      // Handle errors
    }
  };
  
  if(newcode){
    if(urlParams.get('state') === 'linkedin'){
      handleLinkedInCallback(newcode)
    }else if(urlParams.get('state') === 'facebook'){

    }
  }

  const handleEmail = (e) => {
    setemailformat(false);
    let value = e.target.value;
    if (
      /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(value)
    ) {
      setemailformat(true);
      if (
        /^([a-zA-Z0-9_\-\.]+)@(hotmail|outlook)\.([a-zA-Z]{2,5})$/.test(value)
      ) {
        setishotmail(true);
      } else {
        setishotmail(false);
      }
    } else {
      setemailformat(false);
    }
  };

  const handlePassword = (e) => {
    let password = e.target.value;
    let passwordarray = [];
    if (!password.match(".{8,}")) passwordarray.push("8 characters");
    if (!password.match("(?=.*?[0-9])")) passwordarray.push("1 digit");
    setCheckPassword(passwordarray);
  };

  const checkTerm = () => {
    if (!document.getElementById("terms-co-check-linkedin").checked) {
      notify.show("Please accept the Terms and Conditions.");
    } else {
      window.location = `${PORT}/auth/linkedin/login`;
    }
  };

  const setGoogleButton = () => {
    if (!document.getElementById("terms-co-check-google").checked) {
      notify.show("Please accept the Terms and Conditions.");
      setIsGoogleButton(false);
    }
  };

  const handleAcceptBox = () => {
    if (!viewedTermsAndConditions) {
      notify.show(
        "Please view the Terms and Conditions before accepting them."
      );
      document.getElementById("terms-co-check").checked = false;
      return;
    }

    if (!document.getElementById("terms-co-check-google").checked) {
      setIsGoogleButton(true);
    } else {
      setIsGoogleButton(false);
    }
  };

  const showTermsAndCo = () => {
    setViewTermsAndConditions(true);
    setShowPopup(true);
    // document.getElementById('modal-container-TermsAndCo').style.display = 'block';
    //document.getElementById("container").style.height = "0px";
  };
  const hideTermsAndCo = () => {
    setShowPopup(false);
    // document.getElementById('modal-container-TermsAndCo').style.display = 'none';
  };
  const acceptButtonCheck = (flag) => {
    if (flag) {
      document.getElementById("terms-co-check").checked = true;
      setIsGoogleButton(false);
    } else {
      document.getElementById("terms-co-check").checked = false;
      setIsGoogleButton(true);
    }
  };

  return (
    <>
      {/* If isRegistered is true => redirect to home; else stay at login */}
      {isRegistered ? (
        <Redirect to={{ pathname: "/beforeEmailConfirm", emailId: email }} />
      ) : null}
      <SignupContainer
        heading="Sign up as"
        onSubmit={handleSubmit}
        toggle={
          <div className="row justify-content-center login-toggle-container">
            <SignupToggle isChildhoodTeacher={childcare}/>
            {/* <SignupToggle isChildhoodTeacher={props.location.state.is_childhood_teacher}/> */}
          </div>
        }
        google={
          <GoogleDivider
            onSuccess={responseFromGoogle}
            onFailure={responseFromGoogle}
            buttonText="Sign up with Google"
            linkedinText="Sign up with Linkedin"
            linkedinClick={handleLinkedInClick}
            fbText="Sign up with Facebook"
            fbClick={''}
            isRegistered={true}
          />
        }
      >
        {/* Not required as of 8/9/21 - Ming
        <div className="row justify-content-center ">
          <div className="google-button-style"> */}
        {/*                  <div id='google-register-button'
                    onClick={showGoogleRegisterForm}
                    className='h-60 btn btn-block btn-c mx-2 my-2 google-button gray-shadow-box '
                    style={{ width: '100%' }}>
                      <GoogleLogin
                        className='pr-0 google-button google-register-button opacity-100'
                        disabled={true}
                        buttonText=''    >
                      </GoogleLogin>
                  </div>*/}

        {/* <div className="google-button-style">

            </div>

          </div> */}
        {/*                <LinkedInLoginButton
                  id='linkedin-register-button'
                  // onClick={showLinkedinRegisterForm}
                  // disabled={isGoogleButton}
                  disabled={true}
                  align={'center'}
                  className='h-60 w-60 linkedin-button my-auto ml-3 mr-4'
                  // style={{ background: 'rgb(26, 129, 185)' }}
                  >
                   <span>LinkedIn</span>
                  <span> </span>
                </LinkedInLoginButton>
                <button
                  id="email-and-pssw-button"
                  className="h-60 w-60 btn btn-primary btn-block btn-c my-auto primary-button-no-margin-hover rt-button"
                  disabled={isSendingEmail}
                  onClick={showEmailAndPassRegisterForm}
                  ><i className='mdi mdi-email rt-button-icon'></i>
                </button>*/}
        {/* </div> */}

        {/* register with email & password form */}

        {/* <h5 className="text-center mb-4 text-gradient">Register with Email & Password</h5> */}
        {/*              <p className="text-gradient">Please, accept Terms and Conditions to register with us</p>
              <div className=" form-check text-center terms-and-conditions-check h-45 pt-2">
                <div id="r8-balloon-radio-group-wrapper-register">
                  <ul className="register-check-agree">
                    <li>
                      <input className="radio r8-radio-float"
                            id="terms-co-check" type="checkbox"
                            name="balloon-radio-group"/>
                    </li>
                  </ul>
                </div>
                <label htmlFor="terms-co-check" onClick={handleAcceptBox} id="terms-co-check-accept">I Accept</label>
                <label id ="terms-and-conditions-link" onClick={showTermsAndCo} >&nbsp;Terms and Conditions</label>
              </div>*/}
        <div className='center-form'>
          <FormField
            label="Email"
            type="email"
            icon="email"
            placeholder="name@email.com"
            value={email}
            onChange={(e) => (
              setEmail(e.target.value), handleEmail(e)
            )}
            // pattern='/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/'
            title="You must enter a valid email address"
            autoFocus
            required
          />

          <FormField
            label="Password"
            icon="lock"
            type={showPassword ? "text" : "password"}
            placeholder="Enter Your Password"
            value={password}
            onChange={(e) => (setPassword(e.target.value), handlePassword(e))}
            required
            header={
              checkPassword.length > 0
                ? checkPassword.length > 1
                  ? " must contain " +
                    checkPassword[0] +
                    " including " +
                    checkPassword[1]
                  : " must contain " + checkPassword[0]
                : null
            }
          >
            <PasswordToggle onClick={togglePassword} />
          </FormField>
          <PasswordStrengthMeter password={password} />
          <FormField
            label="Confirm Password"
            icon="lock"
            type={showConfirmPassword ? "text" : "password"}
            className={
              confirmPassword !== "" && confirmPassword !== password
                ? "error-form-control"
                : ""
            }
            placeholder="Repeat Your Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          >
            <PasswordToggle onClick={toggleConfirmPassword} />
          </FormField>
        </div>

        <div className="signup-tac">
          <CheckableButton
            className="new-checkable-outer"
            checkbox
            onClick={handleAcceptBox}
            id="terms-co-check"
          >
            <span id="terms-co-check-accept">I Accept</span>
          </CheckableButton>
          <div
            id="terms-and-conditions-link"
            onClick={showTermsAndCo}
            className="terms-conditions"
          >
            &nbsp;Terms and Conditions
          </div>
        </div>

        {/* large screen */}
        <div className="d-flex sign-up-footer justify-content-center">
          <ConfirmButton
            className="signup-button"
            disabled={isSendingEmail}
            onClick={handlePasswordStrength}
            type="submit"
          >
            {/*                      {isSendingEmail ? (
                        <Spinner size='lg' spinning='spinning' />
                      ) : (
                        'Submit'
                      )}*/}
            Submit
          </ConfirmButton>
        </div>

        {/* go to login if user has an account */}
        <LinkToCreateAccount onRegister />

        {/* register with linkedin form */}
        <div id="linkedin-register-form" className="white-bcg">
          <div className="p-5 gray-shadow-box mt-4" id="form-register">
            {/* <h5 className="text-center mb-4 text-gradient">Register with LinkedIn</h5> */}
            <p className="text-gradient">
              Please, accept Terms and Conditions to register with us
            </p>
            <div className=" form-check text-center terms-and-conditions-check h-45 pt-2">
              {/*              <input  id="terms-co-check" type="checkbox" className="check-filter rt-input" />*/}
              <div id="r8-balloon-radio-group-wrapper-register">
                <ul className="register-check-agree">
                  <li>
                    <input
                      className="radio r8-radio-float"
                      id="terms-co-check-linkedin"
                      type="checkbox"
                      name="balloon-radio-group"
                    />
                  </li>
                </ul>
              </div>
              <label
                htmlFor="terms-co-check"
                onClick={handleAcceptBox}
                id="terms-co-check-accept"
              >
                I Accept
              </label>
              <label id="terms-and-conditions-link" onClick={showTermsAndCo}>
                &nbsp;Terms and Conditions
              </label>
            </div>
            <hr className="qualification-line mb-3"></hr>

            {/* large screen */}
            <div className="row qualification-footer small-screen-disappear">
              <div className="col-md-5 mb-1">
                <CancelButton onClick={hideLinkedinRegisterForm}>
                  Cancel
                </CancelButton>
              </div>
              <div className="col-md-7">
                <ConfirmButton className="linkedin-button" onClick={checkTerm}>
                  {isSendingEmail ? (
                    <Spinner size="lg" spinning="spinning" />
                  ) : (
                    "Register with LinkedIn"
                  )}
                </ConfirmButton>
              </div>
            </div>
            {/* small screen */}
            <div className="row qualification-footer  small-screen-appear d-none">
              <div className="col-md-7 mb-1">
                <ConfirmButton className="linkedin-button" onClick={checkTerm}>
                  {isSendingEmail ? (
                    <Spinner size="lg" spinning="spinning" />
                  ) : (
                    "Register with LinkedIn"
                  )}
                </ConfirmButton>
              </div>
              <div className="col-md-5">
                <CancelButton onClick={hideLinkedinRegisterForm}>
                  Cancel
                </CancelButton>
              </div>
            </div>
          </div>
        </div>

        {/* register with google form */}
        <div id="google-register-form" className="white-bcg">
          <div className="p-5 gray-shadow-box mt-4" id="form-register">
            <p className="text-gradient">
              Please, accept Terms and Conditions to register with us
            </p>

            <div className=" form-check text-center terms-and-conditions-check h-45 pt-2">
              <div id="r8-balloon-radio-group-wrapper-register">
                <ul className="register-check-agree">
                  <li>
                    <input
                      className="radio r8-radio-float"
                      id="terms-co-check-google"
                      type="checkbox"
                      name="balloon-radio-group"
                      onClick={handleAcceptBox}
                    />
                  </li>
                </ul>
              </div>
              <label
                htmlFor="terms-co-check"
                onClick={handleAcceptBox}
                id="terms-co-check-accept"
              >
                I Accept
              </label>
              <label id="terms-and-conditions-link" onClick={showTermsAndCo}>
                &nbsp;Terms and Conditions
              </label>
            </div>
            {/* <h5 className="text-center mb-4 text-gradient">Register with Google</h5> */}
            <hr className="qualification-line mb-3"></hr>

            {/* large screen */}
            <div className="row qualification-footer small-screen-disappear">
              <div className="col-md-5 mb-1">
                <CancelButton onClick={hideGoogleRegisterForm}>
                  Cancel
                </CancelButton>
              </div>
              <div className="col-md-7">
                <GoogleLogin
                  className="pr-0 btn btn-primary btn-block primary-button-no-margin-hover btn-c google-button text-white p-2 opacity-100"
                  onSuccess={responseFromGoogle}
                  onFailure={responseFromGoogle}
                  disabled={isGoogleButton}
                  cookiePolicy={"single_host_origin"}
                >
                  <div
                    className="small-screen-google-button"
                    onClick={setGoogleButton}
                    style={{ width: "100%" }}
                  >
                    Register with Google{" "}
                  </div>
                </GoogleLogin>
              </div>
            </div>
            {/* small screen */}
            <div className="row qualification-footer  small-screen-appear d-none">
              <div className="col-md-7 mb-1">
                <GoogleLogin
                  className="pr-0 btn btn-primary btn-block primary-button-no-margin-hover btn-c google-button text-white p-2 opacity-100"
                  onSuccess={responseFromGoogle}
                  onFailure={responseFromGoogle}
                  disabled={isGoogleButton}
                  cookiePolicy={"single_host_origin"}
                >
                  <div
                    className="small-screen-google-button"
                    onClick={setGoogleButton}
                    style={{ width: "100%" }}
                  >
                    Register with Google{" "}
                  </div>
                </GoogleLogin>
              </div>
              <div className="col-md-5">
                <CancelButton onClick={hideGoogleRegisterForm}>
                  Cancel
                </CancelButton>
              </div>
            </div>
          </div>
        </div>
      </SignupContainer>

      <TermsAndConditionsTeacher
        show={showPopup}
        onClose={(event) => {
          // acceptButtonCheck(!document.getElementById("terms-co-check").checked);
          hideTermsAndCo();
        }}
        onCancel={(event) => {
          acceptButtonCheck(false);
          hideTermsAndCo();
        }}
        onConfirm={(event) => {
          acceptButtonCheck(true);
          hideTermsAndCo();
        }}
      />
    </>
  );
};
const mapDispatchToProps = (dispatch) => ({
  updateToRoot: (user) => dispatch(updateToRoot(user)),
});
export default connect(null, mapDispatchToProps)(Register);
